const enhanceMarkerSchemaWithCounter = (markerSchema) => ({
  ...markerSchema,
  fieldsets: [
    ...markerSchema.fieldsets,
    {
      id: 'counter',
      title: 'Counter',
      fields: ['counter', 'popup_text'],
    },
  ],
  properties: {
    ...markerSchema.properties,
    counter: {
      title: 'Counter',
      type: 'number',
      default: 0,
    },
    popup_text: {
      title: 'Popup Text',
      type: 'string',
      widget: 'textarea',
      default: "Empty",
    },
  },
  required: [...(markerSchema.required || [])], // ensure defined
});

export const conditionalMarkerSchemaEnhancer = (schema, formData) => {
  if (formData?.variation === 'counter') {
    const markerField = schema.properties.markers;
    if (markerField?.schema) {
      markerField.schema = enhanceMarkerSchemaWithCounter(markerField.schema);
      markerField.schema.properties.anchor.widget = "hidden";
    }
  }
  return schema;
};

